/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PutUserNewsletterReq } from '../models/put-user-newsletter-req';
import { PutUserProfileInfoReq } from '../models/put-user-profile-info-req';
import { PutUsernameReq } from '../models/put-username-req';
import { PutVatNumberReq } from '../models/put-vat-number-req';
import { UserByModelResp } from '../models/user-by-model-resp';
import { UserDto } from '../models/user-dto';
import { UserGetAllByRolesReq } from '../models/user-get-all-by-roles-req';
import { UserGetAllByRolesResp } from '../models/user-get-all-by-roles-resp';
import { UserGetResp } from '../models/user-get-resp';
import { UserGetSearchReq } from '../models/user-get-search-req';
import { UserGetSearchResp } from '../models/user-get-search-resp';
import { UserUpdateOwnerReq } from '../models/user-update-owner-req';
import { UserUpdateRatingReq } from '../models/user-update-rating-req';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation userGetAllByRoles
   */
  static readonly UserGetAllByRolesPath = '/user/by-roles';

  /**
   * Get all user by roles
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGetAllByRoles()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userGetAllByRoles$Response(params: {
    body: UserGetAllByRolesReq
  }): Observable<StrictHttpResponse<UserGetAllByRolesResp>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.UserGetAllByRolesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserGetAllByRolesResp>;
      })
    );
  }

  /**
   * Get all user by roles
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userGetAllByRoles$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userGetAllByRoles(params: {
    body: UserGetAllByRolesReq
  }): Observable<UserGetAllByRolesResp> {

    return this.userGetAllByRoles$Response(params).pipe(
      map((r: StrictHttpResponse<UserGetAllByRolesResp>) => r.body as UserGetAllByRolesResp)
    );
  }

  /**
   * Path part for operation userPut
   */
  static readonly UserPutPath = '/user';

  /**
   * Update user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userPut$Response(params: {
    body: UserDto
  }): Observable<StrictHttpResponse<UserDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.UserPutPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDto>;
      })
    );
  }

  /**
   * Update user
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userPut(params: {
    body: UserDto
  }): Observable<UserDto> {

    return this.userPut$Response(params).pipe(
      map((r: StrictHttpResponse<UserDto>) => r.body as UserDto)
    );
  }

  /**
   * Path part for operation userGet
   */
  static readonly UserGetPath = '/user/{uuid}';

  /**
   * Get a user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGet$Response(params: {

    /**
     * user uuid
     */
    uuid: string;
  }): Observable<StrictHttpResponse<UserGetResp>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.UserGetPath, 'get');
    if (params) {
      rb.path('uuid', params.uuid, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserGetResp>;
      })
    );
  }

  /**
   * Get a user
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userGet(params: {

    /**
     * user uuid
     */
    uuid: string;
  }): Observable<UserGetResp> {

    return this.userGet$Response(params).pipe(
      map((r: StrictHttpResponse<UserGetResp>) => r.body as UserGetResp)
    );
  }

  /**
   * Path part for operation userGetSearch
   */
  static readonly UserGetSearchPath = '/user/search';

  /**
   * Search
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userGetSearch()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userGetSearch$Response(params: {
    body: UserGetSearchReq
  }): Observable<StrictHttpResponse<UserGetSearchResp>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.UserGetSearchPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserGetSearchResp>;
      })
    );
  }

  /**
   * Search
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userGetSearch$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userGetSearch(params: {
    body: UserGetSearchReq
  }): Observable<UserGetSearchResp> {

    return this.userGetSearch$Response(params).pipe(
      map((r: StrictHttpResponse<UserGetSearchResp>) => r.body as UserGetSearchResp)
    );
  }

  /**
   * Path part for operation userByModel
   */
  static readonly UserByModelPath = '/user/by-model';

  /**
   * User
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userByModel()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userByModel$Response(params: {
    body: UserDto
  }): Observable<StrictHttpResponse<UserByModelResp>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.UserByModelPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserByModelResp>;
      })
    );
  }

  /**
   * User
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userByModel$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userByModel(params: {
    body: UserDto
  }): Observable<UserByModelResp> {

    return this.userByModel$Response(params).pipe(
      map((r: StrictHttpResponse<UserByModelResp>) => r.body as UserByModelResp)
    );
  }

  /**
   * Path part for operation userUpdateRating
   */
  static readonly UserUpdateRatingPath = '/user/update-rating';

  /**
   * Update a user rating
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userUpdateRating()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userUpdateRating$Response(params: {
    body: UserUpdateRatingReq
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.UserUpdateRatingPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Update a user rating
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userUpdateRating$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userUpdateRating(params: {
    body: UserUpdateRatingReq
  }): Observable<any> {

    return this.userUpdateRating$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation userUpdateOwner
   */
  static readonly UserUpdateOwnerPath = '/user/update-owner';

  /**
   * Update a user owner
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userUpdateOwner()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userUpdateOwner$Response(params: {
    body: UserUpdateOwnerReq
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.UserUpdateOwnerPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * Update a user owner
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userUpdateOwner$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userUpdateOwner(params: {
    body: UserUpdateOwnerReq
  }): Observable<any> {

    return this.userUpdateOwner$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation putUserName
   */
  static readonly PutUserNamePath = '{uuid}/username';

  /**
   * Update user name
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putUserName()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putUserName$Response(params: {
    body: PutUsernameReq
  }): Observable<StrictHttpResponse<UserDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.PutUserNamePath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDto>;
      })
    );
  }

  /**
   * Update user name
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putUserName$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putUserName(params: {
    body: PutUsernameReq
  }): Observable<UserDto> {

    return this.putUserName$Response(params).pipe(
      map((r: StrictHttpResponse<UserDto>) => r.body as UserDto)
    );
  }

  /**
   * Path part for operation putNewsletterSubscription
   */
  static readonly PutNewsletterSubscriptionPath = '{uuid}/usernewslettersubs';

  /**
   * Update newsletter subscription
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putNewsletterSubscription()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putNewsletterSubscription$Response(params: {
    body: PutUserNewsletterReq
  }): Observable<StrictHttpResponse<UserDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.PutNewsletterSubscriptionPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDto>;
      })
    );
  }

  /**
   * Update newsletter subscription
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putNewsletterSubscription$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putNewsletterSubscription(params: {
    body: PutUserNewsletterReq
  }): Observable<UserDto> {

    return this.putNewsletterSubscription$Response(params).pipe(
      map((r: StrictHttpResponse<UserDto>) => r.body as UserDto)
    );
  }

  /**
   * Path part for operation putUserProfileInfo
   */
  static readonly PutUserProfileInfoPath = '{uuid}/userprofileinfo';

  /**
   * Update user profile info
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putUserProfileInfo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putUserProfileInfo$Response(params: {
    body: PutUserProfileInfoReq
  }): Observable<StrictHttpResponse<UserDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.PutUserProfileInfoPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDto>;
      })
    );
  }

  /**
   * Update user profile info
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putUserProfileInfo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putUserProfileInfo(params: {
    body: PutUserProfileInfoReq
  }): Observable<UserDto> {

    return this.putUserProfileInfo$Response(params).pipe(
      map((r: StrictHttpResponse<UserDto>) => r.body as UserDto)
    );
  }

  /**
   * Path part for operation putVatNumber
   */
  static readonly PutVatNumberPath = '{uuid}/uservatnumber';

  /**
   * Update user DNI
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putVatNumber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putVatNumber$Response(params: {
    body: PutVatNumberReq
  }): Observable<StrictHttpResponse<UserDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.PutVatNumberPath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDto>;
      })
    );
  }

  /**
   * Update user DNI
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `putVatNumber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  putVatNumber(params: {
    body: PutVatNumberReq
  }): Observable<UserDto> {

    return this.putVatNumber$Response(params).pipe(
      map((r: StrictHttpResponse<UserDto>) => r.body as UserDto)
    );
  }

  /**
   * Path part for operation acceptLegal
   */
  static readonly AcceptLegalPath = '{uuid}/accept-legal';

  /**
   * Accept user name legal terms
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `acceptLegal()` instead.
   *
   * This method doesn't expect any request body.
   */
  acceptLegal$Response(params?: {
  }): Observable<StrictHttpResponse<UserDto>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.AcceptLegalPath, 'put');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserDto>;
      })
    );
  }

  /**
   * Accept user name legal terms
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `acceptLegal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  acceptLegal(params?: {
  }): Observable<UserDto> {

    return this.acceptLegal$Response(params).pipe(
      map((r: StrictHttpResponse<UserDto>) => r.body as UserDto)
    );
  }

  /**
   * Path part for operation assist
   */
  static readonly AssistPath = '/user/assist';

  /**
   * Get user assist
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assist()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assist$Response(params: {
    body: {
'user_name'?: string;
'email'?: string;
'phone'?: string;
}
  }): Observable<StrictHttpResponse<{
'value'?: string;
}>> {

    const rb = new RequestBuilder(this.rootUrl, UserService.AssistPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        'value'?: string;
        }>;
      })
    );
  }

  /**
   * Get user assist
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `assist$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assist(params: {
    body: {
'user_name'?: string;
'email'?: string;
'phone'?: string;
}
  }): Observable<{
'value'?: string;
}> {

    return this.assist$Response(params).pipe(
      map((r: StrictHttpResponse<{
'value'?: string;
}>) => r.body as {
'value'?: string;
})
    );
  }

}
